import { Component, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import {
  EnviormentConfig,
  IConfigObj,
  J4uV1Service,
  OfferDetailService,
  OfferDetailsData,
} from 'abs-ngx-library/src/lib/core';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { B4UService } from 'src/app/shared/services/b4u.service';
import { ContinuityOfferService } from 'src/app/shared/services/continuity-offer.service';
import { LogService } from 'src/app/shared/services/log.service';

declare var $: any;

@Component({
  selector: 'app-offer-detail-card',
  templateUrl: './offer-detail-card.component.html',
  styleUrl: './offer-detail-card.component.scss',
})
export class OfferDetailCardComponent {
  @Input() offer: any;
  @Input() logoProps: any;
  @Input() isUserLoggedIn: boolean = false;
  @Output() onGetOffer: EventEmitter<any> = new EventEmitter<any>();
  configObj: IConfigObj = {
    appName: 'b4u',
  };
  public window: any = window;
  public offerDisclaimerExFrgPath: string = '/content/experience-fragments/www/Disclaimers/Offer-Disclaimer/offer-disclaimer.content.html';
  public isDisclaimerLoaded: boolean = false;
  public bogoText = 'Buy 1 Get 1 Free';
  public bogoTextDetail = 'Add 2 Total for Offer';
  public showSpinner: boolean = false;
  public offerDataForOfferDetailsPage: OfferDetailsData = {};
  public couponType: any = {
    PD: 'Personalized Deal',
    MF: 'Coupon',
    SC: 'Coupon',
    CC: 'Coupon',
    GR: 'Grocery Reward',
    TR: 'Monopoly Prize',
    WS: 'Weekly Ad',
  };
  public couponTypeFull: string = '';
  public sm = '575px';
  public md = '768px';
  public imagePath: string = this.window['AB']['dMTProductCard'];
  public clippedLabel: string = 'Clipped';
  public clipCouponLabel: string = 'Clip Coupon';
  public showLoadingCoupon: boolean = false;
  public iconImage: string = '';
  public isBehaviourOrContinuityCoupon: boolean = false;
  public displayClipCouponForPDOffers: boolean = true;

  constructor(
    private _offerDetailService: OfferDetailService,
    private _j4uV1Service: J4uV1Service,
    private elementRef: ElementRef,
    private continuityOfferService: ContinuityOfferService,
    private authService: AuthService,
    private _logService: LogService,
    private b4UService: B4UService
  ) {
    this.couponType = this.window['SWY'].CONFIGSERVICE.nimbusConfig.couponTypes;
    this.clipCouponLabel =
      this.window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CLC'];
    this.clippedLabel =
      this.window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CLD'];
    this.offerDisclaimerExFrgPath = this.authService.getApplicationDomainURL() + this.offerDisclaimerExFrgPath;
  }

  ngOnInit() {
    this.showLoadingCoupon = true;
    let _envConfig: any = EnviormentConfig;
    this._offerDetailService
      .getOfferDetailData(
        this.offer.offerId,
        this.offer.offerPgm,
        this.configObj
      )
      .subscribe(
        (data: any) => {
          this.onGetOffer.emit(data?.offerDetail?.primaryCategoryNM);
          this.offerDataForOfferDetailsPage = { ...data };
          this.transformDataForOfferDetailsPage(data);
          this.showLoadingCoupon = false;
          // this.offerDataForOfferDetailsPage.disclaimer = data.replace(/<(?:.|\n)*?>/gm, ' ');
          this.couponTypeFull =
            data && data?.offerPgm
              ? this.couponType[data?.offerPgm]
              : this.couponType[this.offer?.offerPgm];
          this.iconImage = this.getIconImage(data);
          this.isBehaviourOrContinuityCoupon = this.continuityOfferService.isBehaviourOrContinuityCoupon(data) || this.continuityOfferService.isFreshpassContinuityCoupon(data);
          // this.isBehaviourOrContinuityCoupon = this.continuityOfferService.isFreshpassContinuityCoupon(data);
          // if (this.isUserLoggedIn && !this.isBehaviourOrContinuityCoupon && !data.status) {
          //   this.isBehaviourOrContinuityCoupon = this.continuityOfferService.isFreshpassContinuityCoupon(data);
          //   if (this.isBehaviourOrContinuityCoupon) this.offerDataForOfferDetailsPage.status = 'C';
          // }
          if (!data?.status) {
            this.displayClipCouponForPDOffers = false;
          }
          if (!this.isDisclaimerLoaded) {
            this._offerDetailService
              .getOfferDisclaimerTemplate(
                this.offerDisclaimerExFrgPath,
                this.configObj
              )
              .subscribe((response: any) => {
                if (response) {
                  $('.offer-details-disclaimer').append(response);
                  this.isDisclaimerLoaded = true;
                }
              });
          }

        },
        (err: any) => {
          this.showLoadingCoupon = false
        }
      );
    // if (!this.offer.status) {
    //   this.offer.status = 'U';
    // }
  }

  public transformDataForOfferDetailsPage(data: any) {
    const abJ4uCouponsData = localStorage.getItem('abJ4uCoupons');
    if ( abJ4uCouponsData && abJ4uCouponsData !== 'undefined' ) {
      let abJ4uCoupons = JSON.parse(abJ4uCouponsData);
      if ( abJ4uCoupons && abJ4uCoupons.objCoupons ) {
        let offer = abJ4uCoupons.objCoupons[data.offerId];
        this.offerDataForOfferDetailsPage.regularPrice = offer.regularPrice
          ? offer.regularPrice
          : '';
      }
    }
    const savings = data.offerDetail.offerPrice
      ? data.offerDetail.offerPrice
      : '';
    this.offerDataForOfferDetailsPage.savings =
      data.priceTitle &&
      data.priceTitle !== '' &&
      savings.indexOf(data.priceTitle) === -1
        ? `${data.priceTitle} ${savings}`
        : savings;
    this.offerDataForOfferDetailsPage.savings =
      this.offerDataForOfferDetailsPage.savings !== ''
        ? this.offerDataForOfferDetailsPage.savings
        : data.offerDetail.forUDescription;
    this.offerDataForOfferDetailsPage.description =
      data.offerDetail.description;
    this.offerDataForOfferDetailsPage.title = data.offerDetail.name;
    this.offerDataForOfferDetailsPage.offerSubPgm = data.offerSubPgm;
    this.offerDataForOfferDetailsPage.programSubType = data.programSubType;
    this.offerDataForOfferDetailsPage.status = data.deleted
      ? 'U'
      : data.status
      ? data.status
      : '';
    this.offerDataForOfferDetailsPage.deleted = data.deleted;
    this.offerDataForOfferDetailsPage.offerId = data.offerId;
    this.offerDataForOfferDetailsPage.offerPgm = data.offerPgm;
    this.offerDataForOfferDetailsPage.endDate = data.offerEndDate;
    this.offerDataForOfferDetailsPage.imageId = data.imageId;
    this.offerDataForOfferDetailsPage.offerProtoType = data.offerProtoType;
    this.offerDataForOfferDetailsPage.continuity = data.continuity;
    this.offerDataForOfferDetailsPage.offerType =
      data.offerPgm === 'TR' &&
      data.usageType === 'U' &&
      data.quantity !== undefined
        ? `${data.quantity} use${
            parseInt(data.quantity) > 1 ? 's' : ''
          } available`
        : this.window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[
            data.usageType
          ];
    this.offerDataForOfferDetailsPage.detail = data.offerDetail.details
      ? data.offerDetail.details
      : '';
  }

  public getImageUrl(viewport: string): string {
    let modifiedImagePath =
      this.imagePath ||
      '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available';
    if (
      this.offerDataForOfferDetailsPage &&
      this.offerDataForOfferDetailsPage.imageId
    ) {
      modifiedImagePath =
        modifiedImagePath
          .replace('${product.id}', this.offerDataForOfferDetailsPage?.imageId)
          .replace('${viewport}', viewport) || '';
    }
    return modifiedImagePath;
  }

  public clipCoupon() {
    if (this._isRegistered()) {
      this.showSpinner = true;
      let storeId = this.window['AB']['userInfo']['j4u']['storeId'];
      const analyticsData: any = {
        nativeElement: this.elementRef.nativeElement,
      };
      this._j4uV1Service
        .clipCoupon(
          this.offerDataForOfferDetailsPage,
          storeId,
          this.configObj,
          false,
          analyticsData
        )
        .pipe(
          finalize(() => {
            this.showSpinner = false;
          })
        )
        .subscribe((response: any) => {
          if (
            response &&
            response['items'] &&
            response['items'][0] &&
            response['items'][0]['status'] === 1
          ) {
            this.offerDataForOfferDetailsPage.status = 'C';
            this.offerDataForOfferDetailsPage.deleted = false;
          }
        });
    }
  }

  public getIconImage(data: any) {
    let iconImage = 'LastBeforeDefaultIconImage';
    const rewardProtoTypes = ['REWARDS_FLAT', 'REWARDS_ACCUMULATION'];
    const freshPassCouponEventListener = [
      'freshpass credit',
      'freshpass perks',
      'freshpass deals',
    ];
    const events = data && data['hierarchies'] && data['hierarchies']['events'];
    let freshPassExist = false;
    for (let i in events) {
      if (
        freshPassCouponEventListener
          .map((e) => e.toLowerCase())
          .indexOf(events[i].toLowerCase()) !== -1
      ) {
        freshPassExist = true;
      } else {
        freshPassExist = false;
        break;
      }
    }
    if (data.programSubType && data.programSubType === 'IA FRESHPASS') {
      freshPassExist = true;
    }
    if (freshPassExist) {
      iconImage = 'FreshPassIconImage'; //only display freshpass logo if ALL events are freshpass event
    }
    if (
      (data.offerProgramType &&
        rewardProtoTypes.includes(data.offerProgramType)) ||
      (data.offerProtoType && rewardProtoTypes.includes(data.offerProtoType))
    ) {
      iconImage = 'RewardsIconImage';
    }

    if (this.configObj?.appName === 'FreshPass') {
      //starts only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
      const freshpassProgramType = ['FRESHPASS', 'FRESHPASS LTO'];
      const programType = data?.programType ?? '';
      iconImage = freshpassProgramType.includes(programType)
        ? 'FreshPassIconImage'
        : 'LastBeforeDefaultIconImage';
      //ends only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
    }
    return iconImage;
  }

  private _isRegistered(): boolean {
    return (
      this.window['AB']['COMMON'].sessionNotExpired() &&
      this.window['AB']['COMMON'].authorize()
    );
  }
}
